import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1068px;
  margin: 20px auto 20px auto;

  display: flex;
  justify-content: space-between;

  ul li {
    display: inline-block;
    margin-right: 15px;
    position: relative;
    a {
      font-size: 11px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: left;
      color: #235f6e;
      font-weight: bold;
      margin-left: 10px;
    }
    :last-child a {
      color: #333;
      font-weight: normal;
    }
    :before {
      content: ' ';
      width: 1px;
      height: 12px;
      background-color: #cccccc;
      display: block;
      transform: rotate(15deg);
      position: absolute;
      bottom: 2px;
    }
  }
`;

export const BoxInstitution = styled.div`
  margin-top: -5px;
  text-align: right;
  color: #2d8499;
  font-size: 12px;
  > p {
    font-weight: bold;
  }

  > span {
  }
`;
